import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { EditAllowedIpComponent } from './containers/edit-allowed-ip.component';
import { EditAllowedIpEffects } from './state/edit-allowed-ip.effects';
import * as fromEditAllowedIp from './state/edit-allowed-ip.reducer';
import { EditAllowedIpViewComponent } from './views/edit-allowed-ip-view.component';
@NgModule({
   declarations: [EditAllowedIpComponent, EditAllowedIpViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,

      EntitySelectModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      MatCheckboxModule,
      MatIconModule,

      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,

      StoreModule.forFeature(fromEditAllowedIp.editAllowedIpFeatureKey, fromEditAllowedIp.reducer),

      EffectsModule.forFeature([EditAllowedIpEffects]),
   ],
})
export class EditAllowedIpModule {}
